import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeaderImage } from 'foundations-components/transitional/components/DialogHeaderImage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import H2 from 'UIComponents/elements/headings/H2';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import { DIALOG_HEADER_IMAGE_ATTR, MODAL_WIDTH } from 'asset-actions-lib-forms/constants/UICssAttrs';
import useGetFormMetadata from 'asset-actions-lib-forms/share/hooks/useGetFormMetadata';
import { RegularFormTypes } from 'asset-actions-lib-forms/constants/form';
import { FORM_ACTION_IDS } from 'asset-actions-lib-forms/constants/actionIds';
import { useAssetActions } from 'asset-actions-lib/context/AssetActionsContext';
import ShareTabbedViewWithHubspot from './ShareTabbedViewWithHubspot';
import ShareTabbedView from './ShareTabbedView';
import EmbedVersions from 'forms-utils-lib/constants/formDefinition/EmbedVersions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ShareFormDialog({
  crmObject,
  onClose,
  scopes,
  initialTab
}) {
  const {
    onActionSuccess
  } = useAssetActions();
  const formGuid = getPropertyValue(crmObject, 'hs_form_id') || '';
  const formName = getPropertyValue(crmObject, 'hs_name') || '';
  const embedVersion = getPropertyValue(crmObject, 'hs_embed_version') || '';
  const shouldShowCtas = scopes.includes('calls-to-action-read');
  const getFormMetadata = useGetFormMetadata(formGuid);
  const embedType = getFormMetadata('embedType');
  const headerI18nKey = embedType === RegularFormTypes.REGULAR ? 'assetActionsLibForms.modals.shareDialog.title.embed' : 'assetActionsLibForms.modals.shareDialog.title.share';
  const trackTabInteraction = actionType => () => {
    if (!onActionSuccess) {
      return;
    }
    onActionSuccess({
      actionId: FORM_ACTION_IDS.SHARE,
      data: {
        actionType
      }
    });
  };
  const tabCommonProps = {
    embedType,
    embedVersion,
    formGuid,
    formName,
    onClose,
    onClickPreviewShareLink: trackTabInteraction('click-share-link'),
    onCopyEmbedCode: trackTabInteraction('copy-embed-code'),
    onCopyShareLink: trackTabInteraction('copy-share-link'),
    initialTab
  };
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "share-form-dialog",
    use: "info",
    size: "auto",
    width: MODAL_WIDTH,
    onEsc: onClose,
    children: [/*#__PURE__*/_jsx(DialogHeaderImage, {
      offsetBottom: DIALOG_HEADER_IMAGE_ATTR.OFFSET_BOTTOM,
      offsetTop: DIALOG_HEADER_IMAGE_ATTR.OFFSET_TOP,
      children: /*#__PURE__*/_jsx(Illustration, {
        alt: I18n.text(headerI18nKey),
        name: "forms",
        width: DIALOG_HEADER_IMAGE_ATTR.ILLUSTRATION_WIDTH
      })
    }), /*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: headerI18nKey
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: shouldShowCtas && embedVersion !== EmbedVersions.V4 ? /*#__PURE__*/_jsx(ShareTabbedViewWithHubspot, Object.assign({
        onClickCMSRoute: trackTabInteraction('click-cms-route'),
        onClickCTARoute: trackTabInteraction('click-cta-route')
      }, tabCommonProps)) : /*#__PURE__*/_jsx(ShareTabbedView, Object.assign({}, tabCommonProps))
    })]
  });
}